export const environment = {
  production: true,
  baseUrl: '/v1'
};
